<template>
  <div class="eachConv">
    <span style="float: left">
      <el-badge
        :value="conversation.unread_count > 0 ? conversation.unread_count : ''"
        :max="100"
        title="消息提醒"
        :ref="'conv' + conversation.id"
      >
        <el-avatar size="small" alt="用户图片" fit="cover" class="alignAvatar">
          <img
            loading="lazy"
            title="用户图片"
            alt="用户图片"
            height="40px"
            width="40px"
            :src="conversation.talkTo.avatar"
          />
        </el-avatar>
        {{ conversation.talkTo.name }}
      </el-badge>
    </span>
    <span class="messageContent" v-if="conversation.last_message">
      <font-awesome-icon
        icon="reply"
        v-show="isMine(conversation.last_message.user_id)"
      />
      {{ conversation.last_message.message.substring(0, 10) }}
    </span>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["conversation"],
  computed: {
    ...mapState(["user"])
  },
  methods: {
    isMine(senderId) {
      return this.user.id === senderId;
    }
  }
};
</script>
<style>
.messageContent {
  /*color: #8492a6;*/
  font-size: 13px;
  float: right;
}
</style>
